export const state = () => ({
	user_settings: {},
	notification_settings: {},
});
export const mutations = {
	setUserSettings(state: any, payload: any) {
		state.user_settings = payload;
		state.notification_settings = payload.notifications;
	},

	setNotificationsSettings(state: any, payload: any) {
		state.notification_settings = payload.notifications;
	},
};
export const getters = {
	getNotificationSettings: (state: any) => state.notification_settings,
	getUserSettings: (state: any) => state.user_settings,
};
export const actions = {
	getUserSettings(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/user/settings')
				.then((res) => {
					state.commit('setUserSettings', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getNotificationSettings(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/user/settings')
				.then((res) => {
					state.commit('setNotificationsSettings', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateNotificationSettings(state: any, payload: any) {
		const settings = JSON.parse(JSON.stringify(state.state.notification_settings));
		const toDB = JSON.parse(JSON.stringify(state.state.user_settings));

		Object.keys(settings).forEach(function (key) {
			if (key == payload.setting) {
				settings[key][payload.index] = !settings[key][payload.index];
			}
		});

		toDB.notifications = settings;

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/user/settings', toDB)
				.then((res) => {
					state.commit('setNotificationsSettings', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
